export enum Routes {
  Admin = '/admin',
  SortingCenterSelection = '/sorting-center',

  AdministrationUserCreate = '/administration/users/create',
  AdministrationUserSortingCenterUserRole = '/administration/users/:userId/sorting-center-user-role',
  AdministrationUserShow = '/administration/users/:userId',
  AdministrationUsers = '/administration/users',
  AdministrationHomepage = '/administration',

  ExpeditionCreate = '/expeditions/create',

  Expeditions = '/expeditions',
  ExpeditionShow = '/expeditions/:expeditionId',
  ExpeditionEdit = '/expeditions/:expeditionId/edit',

  EstimatedReceptions = '/estimated-receptions',
  EstimatedReceptionsEdit = '/estimated-receptions/edit',

  CharacterizationCreate = '/characterizations/create',
  CharacterizationEdit = '/characterizations/:characterizationId/edit',
  CharacterizationShow = '/characterizations/:characterizationId',
  Characterizations = '/characterizations',

  ProductionCreate = '/productions/create',
  ProductionEdit = '/productions/:productionId/edit',
  ProductionShow = '/productions/:productionId',
  Productions = '/productions',

  ReceptionCreate = '/receptions/create',
  ReceptionEdit = '/receptions/:receptionId/edit',
  ReceptionShow = '/receptions/:receptionId',
  Receptions = '/receptions',

  ClosureSuccess = '/closures/:id/success',
  ClosureClose = '/closures/:id/close',
  Closures = '/closures',
  ClientReports = '/reports/client',
  GlobalReports = '/reports/global',
  InboundStocks = '/stocks/inbound',
  ConditionedStocks = '/stocks/conditioned',
  ConditionedStocksByClient = '/stocks/conditioned-by-client',
  StockConditionneParRepreneurPage = '/stocks/conditioned-by-buyer',

  SortingCenterContractCreate = '/referentiels/clients/:clientId/new_sorting_center_contract',
  SortingCenterContractUpdate = '/referentiels/clients/:clientId/contracts/:contractId/stream/:streamId/update_sorting_center_contract',
  ClientShow = '/referentiels/clients/:clientId',
  ClientCreate = '/referentiels/clients/create',
  Clients = '/referentiels/clients',

  BuyerShow = '/referentiels/buyers/:buyerId',
  Buyers = '/referentiels/buyers',
  BuyersCreate = '/referentials/buyers/create',
  SortingCenter = '/referentiels/sorting-center',
  ClientContracts = '/referentials/clients/:clientId/contracts/create',

  Documents = '/documents',
  InfoPage = '/info',

  UserProfile = '/user-profile',
}
